// This file is automatically generated. Do not edit manually.

export const locales = [
  "default",
  "es",
  "fr",
  "nl",
  "de"
] as const

export type Locale = typeof locales[number];
